//WE.Flow.Html.Contracts.Manifests.Components.SilverlightComponentManifest
import { ComponentManifest } from "./ComponentManifest";

export class SilverlightComponentManifest extends ComponentManifest {
    domainId: string = "";
    uICulture: string = "";
    metaServiceLocalUri: string = "";
}
